module.exports = __webpack_public_path__ + "images/1-ru.a5cd5c2aae531391afdd9c785380eccf.jpg";